import request from '@/utils/request';
import { encrypt, xmlPublicKeyToPem } from '@/utils/rsaEncrypt';

export function getPublicKey() {
  return request({
    url: '/api/user/getPublicKey',
  });
}

export async function doLogin(data) {
  data.password = await encrypt(data.password);
  return request({
    url: '/api/user/login',
    data,
  });
}
export async function doLoginByTempToken(data) {
  data.password = await encrypt(data.password);
  return request({
    url: '/api/user/loginByTempToken',
    data,
  });
}

export async function sendVerifycode(data) {
  data.password = await encrypt(data.password);
  return request({
    url: '/api/user/sendVerifycode',
    data,
  });
}

export function getUserInfo() {
  return request({
    url: '/api/user/getUserInfo',
  });
}

export async function fetchPublicKey() {
  const { data } = await request({
    url: '/api/user/getPublicKey',
  });
  const pubKey = data.publicKey;
  // jsencrypt 3.x 不支持 XML 公钥，需转换为 PEM 格式
  data.publicKey = pubKey && pubKey.indexOf('<RSAKeyValue>') !== -1 ? xmlPublicKeyToPem(pubKey) : pubKey;
  return data;
}
export function editPassword(data) {
  return request({
    url: '/api/user/editPassword',
    data: data || {},
  });
}

export function doLogout() {
  return request({
    url: '/api/user/loginOut',
  });
}
